module.exports = __webpack_public_path__ + "media/images/custom-registrations-2-2345eeb3a6dfa0146b0a06920c512ece.svg";